import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Axios from 'axios';

@Component({
  props: {},
  created() {
    if (this.$route.query.name !== undefined && this.$route.query.name !== null) {
      this.$data.valuename = this.$route.query.name;
    }
    if (this.$route.query.id !== undefined && this.$route.query.id !== null) {
      this.$data.valueid = this.$route.query.id;
    }
  }
})

export default class BetterStartForm extends Vue {
  completed: Boolean = false;
  valuename: string = '';
  valueid: string = '';
  option: any = {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(242,242,242)"
  };

  save() {
    var _this = this as any;
    var png = _this.$refs.signature1.save()
    var jpeg = _this.$refs.signature1.save('image/jpeg')
    var svg = _this.$refs.signature1.save('image/svg+xml');
    let self = this;
    Axios.post(`https://services.portal.bettercorp.co.za/Public/FormSignSave/${this.$route.params.formId}/${this.$route.params.uid}`, {
      png,
      jpeg,
      svg,
      valuename: this.valuename,
      valueid: this.valueid,
      query: this.$route.query
    }).then(x => {
      self.$data.completed = true;
    }).catch(x => {
      alert(x);
    })
  }
}
